import React from 'react';
import {useTranslation} from 'react-i18next';

import {FaIcon} from '../FaIcon';
import {
    INFORMATIVE_LOCALE_V21, INFORMATIVE_MATCH, INFORMATIVE_MISSING, compareInformativeBudget, formatInformativeMoney,
} from './informativeBudget';

/**
 * «Tus campañas suman $X; la línea tiene $Y. No te coinciden: faltan $Z.» (card CvdQbnl2).
 *
 * Nunca bloquea: es el aviso rudimentario que se acordó con Pablo para el presupuesto por campaña de
 * una línea global. Reusa el bloque `.mixed-currency-warning` y su regla de color: ámbar cuando no
 * coinciden (hay algo para mirar), `-info` neutro cuando sí.
 *
 * Sin nada que comparar no dibuja nada: una línea global sin presupuestos por campaña se ve igual
 * que antes.
 */
export function InformativeBudgetNotice({lineBudget, campaignsSum, currency, numberLocale = INFORMATIVE_LOCALE_V21}) {
    const {t} = useTranslation();
    const comparison = compareInformativeBudget(lineBudget, campaignsSum);
    if (comparison === null) return null;

    const money = amount => formatInformativeMoney(currency, amount, numberLocale);
    const params = {sum: money(campaignsSum), line: money(lineBudget), difference: money(comparison.difference),
                    interpolation: {escapeValue: false}};

    if (comparison.state === INFORMATIVE_MATCH) {
        return (
            <div className="mixed-currency-warning -info informative-budget-notice" role="status">
                <FaIcon iconName="check" className="mixed-currency-warning__icon"/>
                <span className="mixed-currency-warning__text">{t('informative_budget.match', params)}</span>
            </div>
        );
    }
    return (
        <div className="mixed-currency-warning informative-budget-notice" role="status">
            <FaIcon iconName="exclamation-triangle" className="mixed-currency-warning__icon"/>
            <span className="mixed-currency-warning__text">
                {comparison.state === INFORMATIVE_MISSING
                    ? t('informative_budget.missing', params)
                    : t('informative_budget.excess', params)}
            </span>
        </div>
    );
}
